import { render, staticRenderFns } from "./DropUp.vue?vue&type=template&id=563ebf10&scoped=true&"
import script from "./DropUp.vue?vue&type=script&lang=ts&"
export * from "./DropUp.vue?vue&type=script&lang=ts&"
import style0 from "./DropUp.vue?vue&type=style&index=0&id=563ebf10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ebf10",
  null
  
)

export default component.exports